
const TableCrossView = () => {
  return (
    <div className='h-10 min-w-28 w-28 flex items-center justify-center'>
      <div className='border-t border-t-text-grey rotate-[165deg] w-full' />
    </div>
  )
}

export default TableCrossView
